import Head from 'next/head';
import { defineMessage, useIntl } from 'react-intl';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { useConfig } from '@packages/utilities';
import { useRouter } from 'next/router';

/* TODO: replace frontend-logic with graphql-call to seo-resolver for title and canonical */

const ratingsTitle = defineMessage({
  defaultMessage: 'Kundenbewertungen',
  id: 'customer-ratings.seo.title',
});

const RatingPageSeoFragment = graphql(/* GraphQL */ `
  fragment RatingPageSeoFragment on Product {
    name
    seo(locale: $locale) {
      title
      description
      keywords
    }
  }
`);

interface RatingPageHeadProps {
  data: FragmentType<typeof RatingPageSeoFragment>;
}

/**
 * RatingPageHead component description displayed in storybook
 * */
export const RatingPageHead = ({ data }: RatingPageHeadProps) => {
  const { formatMessage } = useIntl();
  const { asPath } = useRouter();
  const { host, company } = useConfig();
  const product = getFragmentData(RatingPageSeoFragment, data);
  const { name, seo } = product;
  const { title, description, keywords } = { ...seo };

  let pageTitle = formatMessage(ratingsTitle);
  if (title && title.length > 0) {
    pageTitle += ` | ${title.replace('{ProductName}', name)}`;
  } else {
    pageTitle += ` | ${name.concat(' | ').concat(company.seoTitleName)}`;
  }

  return (
    <Head>
      <title>{pageTitle}</title>
      <meta name="robots" content="noodp,noindex,follow" />
      <link href={`https://www.${host.domain}${asPath}`} rel="canonical" />
      {keywords && <meta name="keywords" content={keywords} />}
      {description && (
        <meta
          name="description"
          content={description.replace('{ProductName}', name).replace(/"/g, '&quot;')}
        />
      )}
    </Head>
  );
};
